/**
 * `#all/` rather than `#inbox/`: filing archives the thread when the planner
 * has that switched on, and an archived thread does not resolve under `#inbox`.
 *
 * The account goes in `authuser`, not in the path. `/mail/u/<segment>/` only
 * resolves an *index* (`u/0`, `u/1`); an address there 404s. But the index is
 * positional across the browser's signed-in Google accounts, so a hardcoded 0
 * opens whichever mailbox happens to be first — not necessarily the one this
 * thread is in. `authuser` names the account and lets Gmail pick the index.
 *
 * Either way Gmail can only resolve an account the browser is signed into; a
 * planner signed out of this address gets Gmail's own error page, which is the
 * correct place for that to surface.
 */
export function gmailThreadUrl(address: string, gmailThreadId: string) {
  return `https://mail.google.com/mail/?authuser=${encodeURIComponent(address)}#all/${gmailThreadId}`;
}
